module.exports = __webpack_public_path__ + "static/17-b86f536cd8a627beaa53a7e4b3f6da13.png";